import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import chooseImg from "../assets/home_2.webp";

export default function WhyChooseUs() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  return (
    <div style={styles.section}>
      <div className="py-5">
        <h2
          className="text-center fw-bold mb-5"
          style={{
            fontSize: isMobile ? "22px" : isTablet ? "26px" : "32px",
          }}
        >
          Why Choose Us
        </h2>

        <div className="row align-items-center justify-content-center px-3">
          {/* Left Image */}
          <div className="col-md-5 text-center mb-4 mb-md-0">
            <div
              style={{
                ...styles.imageWrapper,
                transform: isMobile ? "scale(0.9)" : "scale(1)",
              }}
            >
              <div
                style={{
                  ...styles.orangeBlockLeft,
                  width: isMobile ? "100px" : "160px",
                  height: isMobile ? "140px" : "220px",
                }}
              ></div>

              <div
                style={{
                  ...styles.orangeBlockRight,
                  width: isMobile ? "100px" : "160px",
                  height: isMobile ? "140px" : "220px",
                }}
              ></div>

              <img
                src={chooseImg}
                alt="Why Choose Us"
                className="img-fluid"
                style={{
                  ...styles.image,
                  maxHeight: isMobile ? "260px" : isTablet ? "320px" : "400px",
                }}
              />
            </div>
          </div>

          {/* Right Side*/}
          <div
            className="col-md-6"
            style={{ textAlign: isMobile ? "center" : "left" }}
          >
            <p
              style={{
                ...styles.text,
                fontSize: isMobile ? "14px" : "16px",
              }}
            >
              We are a new-age financial service provider committed to making
              loans simple, transparent, and accessible for everyone. Our goal
              is to remove the complexity from traditional lending by offering
              quick approvals, fair interest rates, and flexible loan options.
            </p>

            <p
              style={{
                ...styles.text,
                fontSize: isMobile ? "14px" : "16px",
              }}
            >
              With a strong focus on customer-first support and secure
              processes, we aim to build long-term trust and lasting
              relationships with every customer we serve.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  section: {
    backgroundColor: "#fff",
  },
  imageWrapper: {
    position: "relative",
    display: "inline-block",
  },
  orangeBlockLeft: {
    position: "absolute",
    top: "30px",
    left: "0",
    backgroundColor: "transparent",
    borderRadius: "15px",
    zIndex: 1,
  },
  orangeBlockRight: {
    position: "absolute",
    bottom: "20px",
    right: "0",
    backgroundColor: "transparent",
    borderRadius: "15px",
    zIndex: 1,
  },
  image: {
    position: "relative",
    zIndex: 2,
    borderRadius: "20px",
    objectFit: "cover",
  },
  text: {
    lineHeight: "1.7",
    color: "#555",
    marginBottom: "15px",
  },
};
